import { render } from "./PointsMap.vue?vue&type=template&id=69427fc3&ts=true"
import script from "./PointsMap.vue?vue&type=script&lang=ts"
export * from "./PointsMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__